import { AutocompletePrediction } from '@bridebook/web/app-shared/lib/search/types';
import { isCustomAutocompletePrediction } from '@bridebook/web/app-shared/lib/search/utils/custom-autocomplete-predictions/is-custom-autocomplete-prediction';

export const getCustomPredictionValues = (prediction: AutocompletePrediction) =>
  isCustomAutocompletePrediction(prediction)
    ? [prediction.mainText, prediction.secondaryText]
    : [prediction.structured_formatting.main_text, prediction.structured_formatting.secondary_text];
